module.exports = __webpack_public_path__ + "img/avr.d9c5dd0b.png";